'use strict';

import defaultTemplate from '../../core/default.html';
import botsListTemplate from './bots.list.html';
import botsInfoTemplate from './bots.info.html';

import Bots from './bots.ctrl';

function BotsRouter($urlRouterProvider, $stateProvider) {
  $stateProvider
    .state('main.bots', {
      url: '/bots',
      template: defaultTemplate,
      resolve: {
        // Feature 'b' is only for purchasing bots
        // permission: function($q, utils) {
        //   const CURRENT_ORG_LOCAL_STORAGE_KEY = 'Organizations-Current';
        //   let orgInfo = utils.getStorageItem(CURRENT_ORG_LOCAL_STORAGE_KEY);
        //   let hasFeatureB = utils.hasFeature(orgInfo, 'b');
        //   return hasFeatureB ? $q.resolve() : $q.reject();
        // }
      }
    })
    .state('main.bots.list', {
      url: '/list?:from&:locationId&:organizationId',
      template: botsListTemplate,
      controller: 'BotsListController as vm',
      resolve: {
        permission: ($q, PermissionsService) => {
          return PermissionsService.canIManageBots()
            ? $q.resolve()
            : $q.reject('Route permission check failed: main.bots.list');
        }
      }
    })
    .state('main.bots.info', {
      url: '/info?:tab&:from&:locationId&:organizationId',
      template: botsInfoTemplate,
      controller: 'BotsInfoController as vm',
      resolve: {
        permission: ($q, PermissionsService) => {
          return PermissionsService.canIManageBots()
            ? $q.resolve()
            : $q.reject('Route permission check failed: main.bots.info');
        }
      }
    });
}

export default angular
  .module('bots.router', [
    Bots
  ])
  .config(BotsRouter)
  .name;
